import React from "react";
import _ from "lodash";
import moment from "moment";
import sizeMe from "react-sizeme";
import ReactDOM from "react-dom";
import { LocInfoWindow } from "./LocInfoWindow";

import {
  LadChicletSVG,
  MadChicletSVG,
  BoxChicletSVG,
  BreadCrumbSVG
} from "../../components/chiclets";
//import { min } from "../../../node_modules/moment";

//const positionStringify = pos => `${pos.lat},${pos.lng}`;
const stopPositionStringify = stop =>
  `${stop.location.geofence.properties.center.latitude},${
    stop.location.geofence.properties.center.longitude
  }`;
const shipmentUpdateStringify = pos => `${pos.latitude},${pos.longitude}`;
const HASH_PRECISION = 4;

function stopHasLocation(stop) {
  return (
    stop.location.geofence.properties.center.latitude != null &&
    stop.location.geofence.properties.center.longitude != null
  );
}

function stopIsPending(stop) {
  return stop.arrived_at == null && stop.departed_at == null;
}

function lerp(x, minX, maxX, minY, maxY) {
  return _.max([((x - minX) * (maxY - minY)) / (maxX - minX) + minY, 0.001]);
}

export function getStopLatLong(stop) {
  if (stopHasLocation(stop)) {
    return {
      lat: stop.location.geofence.properties.center.latitude,
      lng: stop.location.geofence.properties.center.longitude
    };
  }

  return { lat: "0", lng: "0" };
}

const GENERIC_HASH_NO_STOPS = "GENERIC_HASH_NO_STOPS";

// Define the Z order of the elements on the map
const EXPECTED_ROUTE_Z_INDEX = 1;
const ACTUAL_ROUTE_Z_INDEX = 2;
const LOCATION_Z_INDEX = 3;
const MAD_Z_INDEX = 4;

const EXPECTED_ROUTE_LINE_WIDTH = 5;
const ACTUAL_ROUTE_LINE_WIDTH = 10;

export function getDistance(p1, p2) {
  return Math.sqrt(
    (p1.lat - p2.lat) * (p1.lat - p2.lat) +
      (p1.lng - p2.lng) * (p1.lng - p2.lng)
  );
}

class RoutingMapView extends React.Component {
  constructor(props) {
    super(props);

    /* 
      In the FV Vue demo, these parameters were linked to a config panel. 
      TODO: Create a similiar functionality to change these values based
      on user input. Hardcoded for now.

      Also, these are the parameters as used in the fv-web-v0 UI
    */
    this.state = {
      routingParameters: {
        mode: "fastest;truck;traffic:enabled",
        limitedWeight: "30.5",
        height: "4.15",
        length: "53",
        truckType: "tractorTruck",
        trailersCount: "1",
        departure: "now",
        representation: "display",
        routeattributes: "waypoints,summary,shape,legs,notes",
        maneuverattributes: "direction,action",
        truckrestrictionpenalty: "soft"
      },
      shipmentHash: {},
      locationsHash: {}
    };

    this.map = null;
    this.mapDiv = null;
    this.mapObjects = {};
    this.shipmentGroupings = {};
    this.currentZoom = 0;
    this.processedShipments = [];

    this.debouncedResizeMap = _.debounce(this.resizeMap, 100);

    //   this.geocoderHandler = this.geocoderHandler.bind(this);
    this.handlerExpectedRoute = this.handlerExpectedRoute.bind(this);
    this.handlerActualRoute = this.handlerActualRoute.bind(this);
    this.markerClickHandler = this.markerClickHandler.bind(this);
    this.mapViewChanged = this.mapViewChanged.bind(this);
  }

  componentDidMount() {
    // Initialize our map, and clear our state
    this.initMap();
    this.setState({ shipmentHash: {}, locationsHash: {} });
    this.shipmentGroupings = {};
    this.processedShipments = [];
  }

  componentWillReceiveProps(nextProps) {
    var _this = this;

    // If a new shipment is added, calculate the route for it
    nextProps.shipments.forEach(function(shipment) {
      if (_.isEmpty(shipment)) {
        return;
      }

      var existingShipment = _this.processedShipments.filter(
        s => s.id === shipment.id
      );

      // If it wasn't found, it's a new shipment
      if (existingShipment.length === 0) {
        _this.processedShipments.push(shipment);
        _this.processNewShipment(shipment);
      }
    });

    const { width, height } = this.props.size;
    if (width !== nextProps.width || height !== nextProps.height) {
      this.debouncedResizeMap();
    }
  }

  // HASH is 0.6first_lat,0.6first_long:0.6last_lat,0.6last_long
  computeHashFromShipment(shipment) {
    const sortedStops = _.sortBy(shipment.shipment_stops, "stop_sequence");

    if (sortedStops.length === 0) {
      return GENERIC_HASH_NO_STOPS;
    }

    const posFirst = getStopLatLong(sortedStops[0]);
    const posLast = getStopLatLong(sortedStops[sortedStops.length - 1]);

    const hash =
      Number(posFirst.lat).toFixed(HASH_PRECISION) +
      "," +
      Number(posFirst.lng).toFixed(HASH_PRECISION) +
      ":" +
      Number(posLast.lat).toFixed(HASH_PRECISION) +
      "," +
      Number(posLast.lng).toFixed(HASH_PRECISION);

    return hash;
  }

  computeHashFromLocation(location) {
    const hash =
      location.location.name +
      ":" +
      Number(location.location.geofence.properties.center.latitude).toFixed(
        HASH_PRECISION
      ) +
      "," +
      Number(location.location.geofence.properties.center.longitude).toFixed(
        HASH_PRECISION
      );

    return hash;
  }

  matchRouteToShipmentHash(route, hashTable) {
    function coordToPos(coordString) {
      const parts = coordString.split(",");
      return {
        lat: Number.parseFloat(parts[0]),
        lng: Number.parseFloat(parts[1])
      };
    }
    function stopToPos(stop) {
      return {
        lat: Number.parseFloat(stop.latitude),
        lng: Number.parseFloat(stop.longitude)
      };
    }

    const startPos = coordToPos(route.shape[0]);
    const endPos = coordToPos(route.shape[route.shape.length - 1]);

    var minError = 9999999.99;
    var hash = "";

    for (var key in hashTable) {
      const sortedStops = _.sortBy(
        hashTable[key][0].shipment_stops,
        "stop_sequence"
      );

      let sPos = { lat: 0, lng: 0 };
      let ePos = { lat: 0, lng: 0 };
      if (sortedStops.length >= 2) {
        sPos = stopToPos(sortedStops[0]);
        ePos = stopToPos(sortedStops[sortedStops.length - 1]);
      }
      const d = getDistance(startPos, sPos) + getDistance(endPos, ePos);
      if (d < minError) {
        minError = d;
        hash = key;
      }
    }

    // Failsafe, if no hash was selected,
    // and there's only one hash, then use that one
    // This can happen if the shipment stops of the
    // shipment don't resolve properly
    if (hash === "") {
      const hashKeys = Object.keys(hashTable);
      if (hashKeys.length === 1) {
        console.log("No matching hash found.  Using the only key.");
        hash = hashKeys[0];
      }
    }

    return hash;
  }

  processNewShipment(shipment) {
    const { shipmentHash } = this.state;
    const { showBreadCrumbs } = this.props;

    // Compute the hash for this shipment
    const hash = this.computeHashFromShipment(shipment);

    const isNewRoute = !(hash in shipmentHash);
    let newArray = [];

    // If we already hae a shipment on this
    // route, use the existing array entry
    if (isNewRoute) {
      newArray = [shipment];
    } else {
      // Matching route, add this shipment to the list
      newArray = shipmentHash[hash].slice();
      newArray.push(shipment);
    }

    // Update our hash with the new or updated array
    var newShipment = {};
    newShipment[hash] = newArray;
    this.setState({
      shipmentHash: _.merge(shipmentHash, newShipment)
    });

    // If this is a new route generate markers and routes
    if (isNewRoute) {
      // Generate the chiclets for this shipment
      this.generateStopChiclets(hash, shipment);

      // Generate the route for this shipment
      this.calculateExpectedRoute(shipment);

      // Auto-resize the map
      this.rescaleMap();
    }

    // add current position to map
    this.updateChiclet(hash);

    // create breadcrumbs if necessary
    if (showBreadCrumbs) {
      // if this a rail shipment, add the rail breadcrumbs
      // for the locations we've received.  If this
      // a truck shipment, call here to calculate the route
      if (_.toLower(shipment.mode_name) === "rail") {
        this.showRailBreadCrumbs(shipment);
      } else {
        this.calculateActualRoute(shipment);
      }
    }
  }

  showRailBreadCrumbs(shipment) {
    const { H } = this.props;
    this.clearMapMarkers(`breadcrumb:${shipment.id}`);

    // add route to map
    let linestring = new H.geo.LineString();

    if (shipment.current_location) {
      shipment.current_location.updates.forEach((obj, i) => {
        const pos = {
          lat: obj.latitude,
          lng: obj.longitude
        };

        const markerName = `breadcrumb:${shipment.id}:${i}`;

        const svg = BreadCrumbSVG({ backgroundColor: "white" });

        const icon = new H.map.Icon(svg, {
          size: { h: 24, w: 24 },
          anchor: { x: 12, y: 12 }
        });

        var marker = new H.map.Marker(pos, { icon: icon });

        this.map.addObject(marker);
        this.mapObjects[markerName] = marker;

        // Creating connecting breadcrumb line
        linestring.pushLatLngAlt(obj.latitude, obj.longitude);
      });

      // Add breadcrumb line if there is more than one update
      if (shipment.current_location.updates.length > 1) {
        let routeLine = new H.map.Polyline(linestring, {
          style: {
            lineWidth: ACTUAL_ROUTE_LINE_WIDTH,
            lineJoin: "round"
          },
          arrows: true
        });

        const arrowStyle = new H.map.ArrowStyle({ frequency: 1 });
        routeLine.setArrows(arrowStyle);
        routeLine.setZIndex(ACTUAL_ROUTE_Z_INDEX);

        this.mapObjects[`breadcrumb_route:${shipment.id}`] = routeLine;
        this.map.addObjects([routeLine]);
      }
    }
  }

  generateStopChiclets(hash, shipment) {
    const { H, showStopSequence, selectedLocationId } = this.props;

    const getStopOrder = (stops, index) => {
      if (index === 0) {
        return "O";
      } else if (index === stops.length - 1) {
        return "D";
      } else {
        return index.toString();
      }
    };

    // The following is more complex than I'd like but
    // not sure of another way to do.  The general concept
    // Is that we need to iterate through the shipment stops
    // and add a chiclet for each stop.  We want to display the order
    // of the stops in a bubble in the upper right.  Also
    // if a stop is visited multiple times, that bubble should reflect that
    // So we will create a hash of the shipment stops and store meta data
    // about each of them.

    // Sort the stops, and generate the chiclet for each of them
    _.sortBy(shipment.shipment_stops, "stop_sequence").forEach((obj, i) => {
      const pos = getStopLatLong(obj);

      // Get a hash which will resolve to the same value if a stop is duplicated
      const locHash = this.computeHashFromLocation(obj);

      // If we've already added this stop, get the list of
      // decorators we have so far.  Otherwise we'll start with
      // a blank list
      var decoratorList = [];
      if (locHash in this.state.locationsHash) {
        decoratorList = this.state.locationsHash[locHash].decorators.slice();

        // Remove the marker that was created before
        this.map.removeObject(this.mapObjects[locHash]);
      }

      // Add the decorator for this stop to our list
      const decorator = getStopOrder(shipment.shipment_stops, i);
      decoratorList.push(decorator);

      // Create a new hash entry to add to the locations hash
      // in our state
      const newLocationInfo = { decorators: decoratorList.slice() };

      var newLocationHash = {};
      newLocationHash[locHash] = newLocationInfo;
      this.setState({
        locationsHash: _.merge(this.state.locationsHash, newLocationHash)
      });

      // Create the chiclet and add it to the map
      const lad = obj.location.lad;
      const width = 48;
      const height = 48;
      const displayedDecorator = showStopSequence ? decoratorList.join() : null;

      let svg = LadChicletSVG({
        lad: lad,
        chicletStyle: BoxChicletSVG,
        decorator: displayedDecorator
      });

      const icon = new H.map.Icon(svg, { size: { h: height, w: width } });
      const marker = new H.map.Marker(pos);
      marker.setIcon(icon);
      marker.setZIndex(LOCATION_Z_INDEX);

      const loc_id = obj.location.id;

      marker.setData({
        id: loc_id,
        pos: pos,
        location: obj.location,
        lad: lad
      });
      marker.addEventListener("tap", this.markerClickHandler);

      this.map.addObject(marker);
      this.mapObjects[locHash] = marker;

      // If this location matches our selected location ID
      // pop up the info bubble for it
      if (loc_id === selectedLocationId) {
        this.markerClickHandler({ target: marker });
      }
    });
  }

  markerClickHandler(e) {
    const { H } = this.props;
    const marker = e.target;

    this.clearInfoBubbles();
    const markerdata = marker.getData();

    let bubble = new H.ui.InfoBubble(markerdata.pos, {
      content: this.getInfoBubble(markerdata.location, markerdata.lad)
    });

    this.ui.addBubble(bubble);
  }

  clearInfoBubbles() {
    let bubbles = this.ui.getBubbles();

    if (!_.isEmpty(bubbles))
      bubbles.forEach(b => {
        this.ui.removeBubble(b);
      });
  }

  getInfoBubble(data, lad) {
    const { eventHandler } = this.props;

    // FIXME: HERE maps requires a string or HTML node. Converting Component to a Node, but feels hacky.
    var tempdiv = document.createElement("div");
    ReactDOM.render(
      <LocInfoWindow data={data} lad={lad} eventHandler={eventHandler} />,
      tempdiv
    );

    return tempdiv;
  }

  calculateExpectedRoute(shipment) {
    const { platform } = this.props;
    const { routingParameters } = this.state;

    let params = {
      ...routingParameters
    };

    // Do not display the expected route for rail
    // shipments, we don't want to show a route
    // along a road for a rail
    if (_.toLower(shipment.mode_name) === "rail") {
      return;
    }

    if (!("shipment_stops" in shipment)) {
      return;
    }

    // If we do not have any stops, we cannot compute a route
    if (!shipment.shipment_stops) {
      return;
    }
    if (shipment.shipment_stops.length < 2) {
      return;
    }

    // If this shipment is delivered and we are showing
    // breadcrumbs, and we have breadcrumbs to show
    // we will skip rendering the expected route
    if (
      shipment.active_status === "delivered" ||
      shipment.active_status === "arrived"
    ) {
      const waypointData = this.computeActualWaypoints(shipment);
      if (waypointData.numWaypoints > 2) {
        return;
      }
    }

    var validStops = true;
    let numWaypoints = 0;
    let firstWaypoint = true;

    _.sortBy(shipment.shipment_stops, "stop_sequence").forEach((stop, i) => {
      if (stopHasLocation(stop)) {
        // DEV-445 for in transit, we want the active route to only waypoint from
        // the current location and through pending stops for the expected route
        // instead of from origin to destination. This clears up some cases where
        // the truck's actual route was noticeably off from the expected.
        if (shipment.active_status === "in_transit" && stopIsPending(stop)) {
          if (firstWaypoint) {
            params[`waypoint${numWaypoints}`] = shipmentUpdateStringify(
              shipment.current_location
            );
            numWaypoints++;
            firstWaypoint = false;
          }
          params[`waypoint${numWaypoints}`] = stopPositionStringify(stop);
          numWaypoints++;
        } else {
          params[`waypoint${numWaypoints}`] = stopPositionStringify(stop);
          numWaypoints++;
        }
      } else {
        validStops = false;
      }
    });

    // We can only calculate a route if we have valid stops
    if (validStops) {
      const router = platform.getRoutingService();
      router.calculateRoute(params, this.handlerExpectedRoute, e => alert(e));
    } else {
      console.log(
        "Stops along this route do not have a geofence.  Cannot generate route"
      );
    }
  }

  getActualDeliveryTimeWindow(shipment) {
    if (shipment.shipment_stops < 2) {
      return { minTime: null, maxTime: null };
    }

    // Sort the stops by sequence
    const sortedStops = _.sortBy(shipment.shipment_stops, "stop_sequence");

    // Some shipments miss the pickup geofence, but trigger the other
    var minTime = sortedStops[0].arrived_at;

    // If min time is null, check the other stops
    // for an arrived at, if there is,
    // set the min time to low, non-null
    // value, so all breadcrumbs will be displayed
    if (minTime === null) {
      minTime = moment.utc(1).format();

      // We now show all breadcrumbs if the origin doesn't have an arrived_at value.
      // Regardless of the state of the other stops.
      // sortedStops.forEach(obj => {
      //   if (obj.arrived_at) {
      //     minTime = moment.utc(1).format();
      //   }
      // });
    }

    const maxTime = sortedStops[sortedStops.length - 1].arrived_at;

    return { minTime: minTime, maxTime: maxTime };
  }
  computeActualWaypoints(shipment) {
    const { routingParameters } = this.state;
    let params = {
      ...routingParameters
    };

    // We need to prune down the number of waypoints
    // we query, so don't add a waypoint unless we've
    // moved enough
    let numWaypoints = 0;

    const DIST_THRESHOLD = 0.01;

    let lastPos = { lat: 0.0, lng: 0.0 };

    // We don't want to show any breadcrumbs outside
    // of the origin pickup and destination dropoff
    // Extract those times from our stops
    const timeWindow = this.getActualDeliveryTimeWindow(shipment);

    // Make sure we've received some updates AND
    // we have arrived at our origin ( eg, the timewindow min
    // value exists )
    if (shipment.current_location && timeWindow.minTime) {
      shipment.current_location.updates.forEach((obj, i) => {
        // Make sure this doesn't fall outside our actual
        // delivery window, check for before pickup
        if (obj.time < timeWindow.minTime) {
          return;
        }

        // If it's been delivered, skip later updates
        if (timeWindow.maxTime && obj.time > timeWindow.maxTime) {
          return;
        }

        let pos = { lat: Number(obj.latitude), lng: Number(obj.longitude) };
        if (getDistance(lastPos, pos) > DIST_THRESHOLD) {
          lastPos = pos;
          params[`waypoint${numWaypoints}`] = shipmentUpdateStringify(obj);
          numWaypoints += 1;
        }
      });

      if (numWaypoints >= 2) {
        // Add current location as a waypoint to extend actual route
        params[`waypoint${numWaypoints}`] = shipmentUpdateStringify(
          shipment.current_location
        );
        numWaypoints += 1;
      }
    }

    return { params: params, numWaypoints: numWaypoints };
  }

  calculateActualRoute(shipment) {
    const { platform } = this.props;

    const waypointData = this.computeActualWaypoints(shipment);

    if (waypointData.numWaypoints > 1) {
      const router = platform.getRoutingService();
      router.calculateRoute(waypointData.params, this.handlerActualRoute, e =>
        alert(e)
      );
    }
  }

  handlerActualRoute(result) {
    const { H } = this.props;
    const { shipmentHash } = this.state;

    let route = result.response ? result.response.route[0] : null;

    if (route === null) {
      console.log("ERROR getting route from HERE");
      console.log(result);
    }

    if (route) {
      const hash = this.matchRouteToShipmentHash(route, shipmentHash);

      // add route to map
      let linestring = new H.geo.LineString();

      route.shape.forEach(point => {
        var parts = point.split(",");
        linestring.pushLatLngAlt(parts[0], parts[1]);
      });

      let routeLine = new H.map.Polyline(linestring, {
        style: {
          lineWidth: ACTUAL_ROUTE_LINE_WIDTH,
          lineJoin: "round"
        },
        arrows: true
      });

      const arrowStyle = new H.map.ArrowStyle({ frequency: 1 });
      routeLine.setArrows(arrowStyle);

      //      routeLine.setStyle(routeLine.getStyle().getCopy({ strokeColor: color }));
      routeLine.setZIndex(ACTUAL_ROUTE_Z_INDEX);

      this.mapObjects[`actual_route:${hash}`] = routeLine;
      this.map.addObjects([routeLine]);
    }
  }

  clearMapMarkers(prefix) {
    var delList = [];
    for (var key in this.mapObjects) {
      if (key.includes(prefix)) {
        this.map.removeObject(this.mapObjects[key]);
        delList.push(key);
      }
    }
    delList.forEach(value => {
      delete this.mapObjects[value];
    });
  }

  getDisplayedAssetLocation(shipment) {
    // If no current location, can't do anything
    if (!shipment.current_location) {
      return null;
    }

    // Call the method to get our max time
    const timeWindow = this.getActualDeliveryTimeWindow(shipment);

    // If we have a delivered time, set the asset
    // at the final destination
    if (timeWindow.maxTime) {
      const sortedStops = _.sortBy(shipment.shipment_stops, "stop_sequence");
      return {
        lat:
          sortedStops[sortedStops.length - 1].location.geofence.properties
            .center.latitude,
        lng:
          sortedStops[sortedStops.length - 1].location.geofence.properties
            .center.longitude
      };
    } else {
      return {
        lat: shipment.current_location.latitude,
        lng: shipment.current_location.longitude
      };
    }
  }

  computeShipmentGroupings(hash) {
    const { shipmentHash } = this.state;

    // ZOOM  Distance
    //
    //  3     5.0
    //  8     0.14      10 m
    const zoom = this.map.getZoom();
    const groupDistance = lerp(zoom, 3, 8, 5.0, 0.14);

    var shipmentGrouping = [];

    // Walk through each shipment and determine the groupings
    const sortedShipments = _.sortBy(shipmentHash[hash], "shipment_id");
    sortedShipments.forEach((shipment, i) => {
      // Call our helper method to get the displayable
      // asset location.  This method prevents the UI
      // updating the asset location beyond the final destination
      const pos = this.getDisplayedAssetLocation(shipment);

      if (!pos) {
        return;
      }

      // Is this position close to any of our other groupings
      var newGrouping = true;

      // TODO make this grouping dependent upon map zoom level
      shipmentGrouping.forEach(group => {
        const d = getDistance(group.pos, pos);
        if (d < groupDistance) {
          newGrouping = false;
          group.shipments.push(shipment);
        }
      });

      if (newGrouping) {
        shipmentGrouping.push({ pos: pos, shipments: [shipment] });
      }
    });

    const existingGrouping = _.get(this.shipmentGroupings, hash, []);

    var modified = existingGrouping.length !== shipmentGrouping.length;

    if (!modified) {
      // Check each list
      existingGrouping.forEach((value, i) => {
        if (value.shipments.length !== shipmentGrouping[i].shipments.length) {
          modified = true;
        }
      });
    }

    this.shipmentGroupings[hash] = shipmentGrouping;
    return modified;
  }

  // TODO call this method for every hash everytime we zoom the map
  updateChiclet(hash) {
    // Check to see if our groupings have changed
    // only remove and recreate chiclets if the groupings
    // have changed ( method returns bool)
    if (this.computeShipmentGroupings(hash) === false) {
      return;
    }

    // Remove any existing marker we may have for this route
    // Looks like a draw issue that the initial chiclet
    // draw isn't getting cleared when we draw the new one
    this.clearMapMarkers(`current_position:${hash}`);

    // Add a chiclet for each shipment group we came up with
    const grouping = this.shipmentGroupings[hash];
    grouping.forEach((group, i) => {
      // FIXME, promote exceptions
      const activeException = group.shipments[0].active_exceptions_ng;

      const markerName = `current_position:${hash}:${i}`;

      this.addMadMarker(
        markerName,
        group.shipments[0].mode_name,
        activeException,
        group.pos,
        group.shipments.length,
        35,
        35
      );
    });
  }

  handlerExpectedRoute(result) {
    const { H } = this.props;
    const { shipmentHash } = this.state;

    let route = result.response.route[0];

    if (route) {
      // add route to map
      let linestring = new H.geo.LineString();

      route.shape.forEach(point => {
        var parts = point.split(",");
        linestring.pushLatLngAlt(parts[0], parts[1]);
      });

      let routeLine = new H.map.Polyline(linestring, {
        style: { lineWidth: EXPECTED_ROUTE_LINE_WIDTH }
      });
      routeLine.setZIndex(EXPECTED_ROUTE_Z_INDEX);

      const hash = this.matchRouteToShipmentHash(route, shipmentHash);

      this.mapObjects[`expected_route:${hash}`] = routeLine;
      this.map.addObjects([routeLine]);
    }
  }

  initMap() {
    const { H, platform } = this.props;

    let defaultLayers = platform.createDefaultLayers();

    this.map = new H.Map(this.mapDiv, defaultLayers.normal.map, {
      zoom: 5,
      center: { lat: 41.8625, lng: -87.6166 }
      // pixelRatio: Math.min(2, devicePixelRatio)
    });

    this.behavior = new H.mapevents.Behavior(
      new H.mapevents.MapEvents(this.map)
    );

    this.map.addEventListener("mapviewchangeend", this.mapViewChanged);

    this.ui = H.ui.UI.createDefault(this.map, defaultLayers);
    this.ui.getControl("zoom").setAlignment("right-bottom");
    this.ui.setUnitSystem(H.ui.UnitSystem.IMPERIAL);
  }

  clearMap() {
    if (!_.isNil(this.mapObjects) && !_.isEmpty(this.mapObjects)) {
      _.forOwn(this.mapObjects, (val, key) => {
        this.map.removeObject(val);
      });

      this.mapObjects = {};
    }

    this.mapObjects = {};
  }

  resizeMap() {
    if (this.map) {
      this.map.getViewPort().resize();
    }
  }

  rescaleMap() {
    const { shipmentHash } = this.state;
    const { H } = this.props;

    const boundsBuffer = 0.01;
    const getBoundsRect = pos =>
      new H.geo.Rect(
        pos.lat - boundsBuffer,
        pos.lng - boundsBuffer,
        pos.lat + boundsBuffer,
        pos.lng + boundsBuffer
      );

    if (this.map) {
      let boundRect = null;
      // Cycle through all the locations in all our
      // shipments and add them to our bounding rect
      for (var hash in shipmentHash) {
        const shipmentList = shipmentHash[hash];

        for (var shipmentIndex in shipmentList) {
          const shipment = shipmentList[shipmentIndex];
          for (var stopIndex in shipment.shipment_stops) {
            const stop = shipment.shipment_stops[stopIndex];
            if (stopHasLocation(stop)) {
              const pos = getStopLatLong(stop);
              if (boundRect === null) {
                boundRect = getBoundsRect(pos);
              } else {
                boundRect = boundRect.mergeRect(getBoundsRect(pos));
              }
            } else {
              console.log("Stop without location details:");
              console.log(stop);
            }
          }
        }
      }

      if (boundRect != null) {
        this.map.getViewPort().resize();
        this.map.setViewBounds(boundRect);
      }
    }
  }

  mapViewChanged() {
    const { shipmentHash } = this.state;

    const zoom = this.map.getZoom();

    if (zoom !== this.currentZoom) {
      for (var key in shipmentHash) {
        this.updateChiclet(key);
      }

      this.currentZoom = zoom;
    }
  }

  addMadMarker(
    markerName,
    shipmentMode,
    activeException,
    position,
    shipmentCount,
    height = 45,
    width = 45
  ) {
    const { H } = this.props;

    let svg = MadChicletSVG({ shipmentMode, activeException, shipmentCount });

    const icon = new H.map.Icon(svg, { size: { h: height, w: width } });
    const marker = new H.map.Marker(position);
    marker.setZIndex(MAD_Z_INDEX);
    marker.setIcon(icon);

    this.map.addObject(marker);
    this.mapObjects[markerName] = marker;
  }

  render() {
    return (
      <div
        id="routes-map"
        style={{ height: "100%", width: "100%" }}
        ref={el => (this.mapDiv = el)}
      />
    );
  }
}

export default sizeMe({ monitorHeight: true })(RoutingMapView);



// WEBPACK FOOTER //
// ./src/modules/map/RoutingMapView.js